import { Column, Entity } from 'typeorm';
import { GenericModel } from '@nsk-app/models/genericModel';

@Entity()
export class MediaFile extends GenericModel {

  @Column()
  url: string;

  @Column()
  thumb: string;
}
